"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLogoutConfirmationEvent = exports.Name = void 0;
const Name = exports.Name = 'user-logout-confirmation';
const UserLogoutConfirmationEvent = exports.UserLogoutConfirmationEvent = Name;
